/**
 * Merged sender/text lists + template sync for Edit Sent form.
 */

import type { Dispatch, SetStateAction } from 'react';

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

import { useEditSentDropMergedLists } from './useEditSentDropMergedLists';
import { useSentDropTemplateSync } from './useSentDropTemplateSync';

interface Args {
  drops: PreparedDrop[];
  countryKey: string;
  routeId: number | '';
  senderNames: string[];
  smsTexts: string[];
  localSenders: string[];
  localTexts: string[];
  selectedSenderNames: string[];
  setSelectedSenderNames: Dispatch<SetStateAction<string[]>>;
  onAddSender?: (name: string) => Promise<void>;
}

export function useEditSentDropListsAndTemplate(a: Args) {
  const effectiveRouteIdForTemplates = a.routeId !== '' && a.routeId > 0 ? a.routeId : 0;
  const { sendersList, textsList } = useEditSentDropMergedLists(
    a.drops,
    a.senderNames,
    a.smsTexts,
    a.localSenders,
    a.localTexts,
  );
  const template = useSentDropTemplateSync(
    a.countryKey,
    effectiveRouteIdForTemplates,
    a.selectedSenderNames,
    a.setSelectedSenderNames,
    sendersList,
    a.onAddSender,
  );
  return { sendersList, textsList, effectiveRouteIdForTemplates, ...template };
}
